import { ProfileAvatarPreview } from 'src/features/common/profile/components/profile-avatar-preview';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { Visible } from 'src/ui/common/layouts/visible';
import { media } from 'src/ui/common/mixins/media';
import { ShowMoreText } from 'src/ui/common/organisms/show-more-text';
import styled from 'styled-components';

export const StyledEntityAvatar = styled(ProfileAvatarPreview)`
    height: 94px;
    width: 94px;
    padding: 5px;
    border: 2px solid ${({ theme }) => theme.colors.white};
    background: linear-gradient(180deg, #ffb7b7 0%, #727272 100%),
        radial-gradient(60.91% 100% at 50% 0%, #ffd1d1 0%, #260000 100%),
        linear-gradient(127.43deg, #00ffff 0%, #ffffff 100%),
        radial-gradient(100.22% 100% at 70.57% 0%, #ff0000 0%, #00ffe0 100%),
        linear-gradient(64.82deg, #dbff00 0%, #3300ff 100%);
    background-blend-mode: screen, overlay, color-burn, color-dodge, normal;

    ${media.sm`
        height: 125px;
        width: 125px;
  `}

    ${media.md`
        width: 150px;
        height: 150px;
  `}
`;

export const StyledSocialsList = styled(FlexBox)`
    margin-left: auto;
    border-right: 1px solid ${({ theme }) => theme.colors.black};
    margin-right: 16px;
    padding-right: 16px;

    & > a + a {
        margin-left: 5px;
    }
`;

export const StyledDropDownItem = styled.a<{ noSeparator?: boolean }>`
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 40px;
    min-width: 160px;
    color: white;

    & svg {
        margin: 0 10px;
    }

    & + & {
        margin-top: 5px;
    }

    &:last-child {
        ${({ noSeparator, theme }) =>
            !noSeparator &&
            `
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid ${theme.colors.gs400};
    `}
    }
`;

export const StyledContainer = styled.div`
    position: relative;
    width: 100%;
    display: grid;
    align-items: flex-end;
    padding: 0 10px;
    bottom: 44px;
    margin-bottom: -44px;
    grid-template-columns: 94px minmax(170px, auto) auto;
    column-gap: 20px;

    ${media.sm`
    padding: 0 20px;
    bottom: 65px;
    margin-bottom: -65px;
    grid-template-columns: 125px auto auto;
  `}

    ${media.md`
    padding-left: 80px;
    padding-right: 40px;
    bottom: 92px;
    margin-bottom: -92px;

    grid-template-columns: 150px auto auto;
  `}
`;

export const StyledSocialsContainer = styled(FlexBox)`
    margin-left: -10px;
`;

export const StyledVisible = styled(Visible)`
    grid-column: 3/4;
`;

export const StyledTitle = styled(Typography)`
    color: ${({ theme }) => theme.colors.warmBlack};
    margin-top: 20px;
    padding: 0 10px;

    ${media.sm`
        font-size: 31px;
        margin-top: 32px;
        padding: 0 20px;

  `}

    ${media.md`
        font-size: 39px;
        padding: 0 80px;
  `}
`;

export const StyledDescription = styled(ShowMoreText)`
    margin: 10px 0 20px 0;
    padding: 0 10px;
    color: ${({ theme }) => theme.colors.warmBlack};

    ${media.sm`
        font-size: 18px;
        padding: 0 20px;
        margin-top: 16px;
  `}

    ${media.md`
        padding: 0 80px;
  `}
`;

export const StyledSite = styled.a`
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    max-width: 152px;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.black};

    span {
        margin-left: 10px;
        white-space: nowrap;
        display: inline-block;
    }
`;
